import { ComponentProps, FC, useState } from 'react';

import { Input } from '../../components/ui/Input';

interface Props
    extends Omit<ComponentProps<typeof Input>, 'value' | 'onChange'> {
    readonly value: number;
    readonly onChangeValue: (value: number) => void;
}

export const OfferQuantityInput: FC<Props> = ({
    value,
    onChangeValue,
    onFocus,
    onBlur,
    ...props
}) => {
    const [localValue, setLocalValue] = useState(value.toString());
    const [prevValue, setPrevValue] = useState(value);

    if (value !== prevValue) {
        setPrevValue(value);
        setLocalValue(value.toString());
    }

    return (
        <Input
            {...props}
            value={localValue}
            onFocus={(event) => {
                setLocalValue('');
                onFocus?.(event);
            }}
            onBlur={(event) => {
                setLocalValue(value.toString());
                onBlur?.(event);
            }}
            onChange={(event) => {
                const nextValue = event.target.value;
                setLocalValue(nextValue);

                const parsedValue = Number.parseInt(nextValue, 10);
                if (!Number.isNaN(parsedValue)) {
                    onChangeValue(parsedValue);
                }
            }}
        />
    );
};
